(function (angular) {
    "use strict";
    angular.module('smartpublic.core')
        .factory('ProvidersFactory', ProvidersFactory);

    ProvidersFactory.$inject = ['$log', '$http', '$q', 'BASE_URL'];

    function ProvidersFactory($log, $http, $q, BASE_URL) {


        return {
            getProviders: getProviders,
            getDistricts: getDistricts,
            getMunicipalities: getMunicipalities,
            getSpecialty: getSpecialty
        }

        function getProviders(request) {
            var reqSanatize=angular.copy(request);
            reqSanatize.pageSize=parseInt(reqSanatize.pageSize);
            return $http.post(BASE_URL + 'prestadores', reqSanatize);
        }

        function getDistricts(municipalityCode) {
        	if(municipalityCode) {
        		//districtById/{municipalityCode}
        		return $http.get(BASE_URL + 'districtById/' + municipalityCode);
        	} else {
        		return $http.get(BASE_URL + 'distritos');
        	}
        }
        
        function getMunicipalities(districtCode) {
        	if(districtCode) {
        		//municipalityById/{districtCode}
        		return $http.get(BASE_URL + 'municipalityById/' + districtCode);
        	} else {
        		return $http.get(BASE_URL + 'municipios');
        	}
        }
        
        function getSpecialty() {
        	return $http.get(BASE_URL + 'especialidadesMedicas');
        }

    }

})
(angular);